<template>
  <div>
    <!--<div class="flex flex-between mb8">
      <div class="header-time-box" v-if="$store.state.role === 'school-role'">
        申报时间：{{ startTime }}—{{ endTime }}
      </div>
      <div class="" v-else></div>
    </div>-->
    <div class="header-search-box flex align-items-center border-box">
      <div class="flex align-items-center" style="margin-right: 10px">
        <div v-if="this.$route.name === 'szStudio'" style="width: 80px">
          工作室名称 :
        </div>
        <div
          v-if="this.$route.name === 'educationalBrand'"
          style="width: 160px"
        >
          特色文化育人品牌名称:
        </div>
        <div v-if="this.$route.name === 'szMicroClass'" style="width: 100px">
          思政微课名称:
        </div>
        <!--class="input-style"-->
        <a-input
          style="width: 120px"
          type="text"
          v-model="queryCriteria.name"
          allowClear
          placeholder=""
        />
      </div>
      <div class="flex align-items-center">
        <div>申报年份：</div>
        <a-date-picker
          style="margin-right: 10px"
          v-model="queryCriteria.applyYear"
          :open="yearShowOne"
          :locale="locale"
          :format="'YYYY'"
          mode="year"
          @openChange="openChangeOne"
          @panelChange="panelChangeOne"
        />
      </div>
      <div class="flex align-items-center">
        <div>审核状态：</div>
        <a-select
          default-value="全部"
          :style="{ width: isTwoLevelModule ? '168px' : '120px' }"
          v-model="queryCriteria.auditState"
          @change="handleChange"
        >
          <a-select-option value=""> 全部 </a-select-option>
          <a-select-option
            v-for="opt in twoLevelFilterOptions"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.label }}
          </a-select-option>
        </a-select>
      </div>
      <div
        class="search-btn flex flex-center align-items-center"
        @click="inquire"
      >
        <img class="img-box" src="../../assets/images/img48.png" alt="" />
        <div>查询</div>
      </div>
      <div
        class="add-btn search-btn"
        @click="pl(0)"
        v-if="this.$store.state.role == 'education-role'"
      >
        批量通过
      </div>
      <div
        class="add-btn search-btn"
        @click="pl(1)"
        v-if="this.$store.state.role == 'education-role'"
      >
        批量驳回
      </div>
      <!-- <div class="add-btn search-btn"  @click="pl(2)">
     		   批量撤销审核
      </div> -->
      <!--<div class="add-btn"  @click="inquire(1)">
     		 导出
      </div>-->
    </div>
    <div>
      <a-table
        style="text-align: center"
        :locale="{ emptyText: '暂无数据' }"
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :pagination="pagination"
        :row-selection="rowSelection"
        @change="handleTableChange"
        :bordered="true"
        rowKey="id"
        :scroll="{ x: 1280 }"
      >
        <template slot="sequenceNumber" slot-scope="text, record, index">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template slot="tdcy" slot-scope="text, record">
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;justify-content: center;"
	            @click="teacherlist(record)"
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
          <div
            @click="teacherlist(record)"
            style="color: #e5914b; cursor: pointer"
          >
            {{ text }}
          </div>
        </template>
        <template slot="xtdcy" slot-scope="text, record">
          <div
            @click="xteacherlist(record)"
            style="color: #e5914b; cursor: pointer"
          >
            {{ text }}
          </div>
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;justify-content: center;"
	            @click="xteacherlist(record)"
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
        </template>
        <template slot="zjyl" slot-scope="text, record">
          <div
            class="flex align-items-center"
            style="cursor: pointer; justify-content: center"
            @click="zjlist(record)"
          >
            <img
              class="img-box-preview"
              src="../../assets/images/img51.png"
              alt=""
            />
            <span>预览</span>
          </div>
        </template>
        <template slot="ppjd" slot-scope="text, record">
          <div @click="ppjd(record)" style="color: #e5914b; cursor: pointer">
            {{ text }}
          </div>
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;justify-content: center;"
	            @click="ppjd(record)"
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
        </template>
        <template slot="pphd" slot-scope="text, record">
          <div @click="pphd(record)" style="color: #e5914b; cursor: pointer">
            {{ text }}
          </div>
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;justify-content: center;"
	            @click="pphd(record)"
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
        </template>
        <template slot="auditState" slot-scope="text, record">
          <div v-if="isTwoLevelModule" :style="{ color: courseStatusColor(record) }">
            {{ courseStatusText(record) }}
          </div>
          <template v-else>
            <div v-if="text == '0'">已保存</div>
            <div v-if="text == '1'" style="color: #1890ff">待审核</div>
            <div v-if="text == '2'" style="color: rgb(46 190 73)">审核通过</div>
            <div v-if="text == '3'" style="color: #e1301e">审核驳回</div>
          </template>
        </template>
        <template slot="cgyl" slot-scope="text, record">
          <div @click="cglist(record)" style="color: #e5914b; cursor: pointer">
            {{ text }}
          </div>
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;justify-content: center;"
	            @click="cglist(record)"
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
        </template>
        <template slot="brandArea" slot-scope="text, record">
          <div
            @click="arealist(record)"
            style="color: #e5914b; cursor: pointer"
          >
            {{ text }}
          </div>
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;justify-content: center;"
	            @click="arealist(record)"
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
        </template>
        <template slot="sbs" slot-scope="text, record">
          <div v-if="record.hasDeclaration == '0'">未上传</div>
          <div
            v-else
            @click="sbs(record)"
            style="color: #e5914b; cursor: pointer"
          >
            已上传
          </div>
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;justify-content: center;"
	            @click="sbs(record)"
	            v-else
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
        </template>
        <template slot="sp" slot-scope="text, record">
          <div v-if="record.hasResource == '0'">未上传</div>
          <div
            v-else
            @click="sp(record)"
            style="color: #e5914b; cursor: pointer"
          >
            已上传
          </div>
          <!-- <div
	            class="flex align-items-center"
	            style="cursor: pointer;justify-content: center;"
	            @click="sp(record)"
	            v-else
	          >
	            <img
	              class="img-box-preview"
	              src="../../assets/images/img51.png"
	              alt=""
	            />
	            <span>预览</span>
	          </div> -->
          <!--<template slot="applyFilesFull" slot-scope="text">
          <img
            v-if="text == 0"
            class="img-box-hint"
            src="../../assets/images/img57.png"
            alt=""
            title="资料完整"
          />
          <img
            v-else
            class="img-box-hint"
            src="../../assets/images/img58.png"
            alt=""
            title="资料不完整"
          />-->
        </template>

        <span class="flex flex-around" slot="action" slot-scope="record">
          <template v-if="$store.state.role === 'score-role'">
            <div
              class="flex align-items-center"
              style="cursor: pointer; color: #e5914b"
              @click="previews(record)"
            >
              <span>评分</span>
            </div>
          </template>
          <template v-else>
            <div
              class="flex align-items-center"
              style="cursor: pointer; color: #e5914b"
              v-if="canEducationAudit(record)"
              @click="approved('0', record)"
            >
              <!--<img class="img-box" src="../../assets/images/img42.png" alt="" />-->
              <span>审核通过</span>
            </div>
            <div
              class="flex align-items-center"
              style="cursor: pointer; color: #e5914b"
              v-if="canEducationAudit(record)"
              @click="approved('1', record)"
            >
              <!--<img class="img-box" src="../../assets/images/img43.png" alt="" />-->
              <span>审核驳回</span>
            </div>
            <div
              class="flex align-items-center"
              style="cursor: pointer; color: #e5914b"
              v-if="
                (record.auditState == '2' || record.auditState == '3') &&
                $store.state.role != 'education-guide-role'
              "
              @click="chsh(record)"
            >
              <!--<img class="img-box" src="../../assets/images/img43.png" alt="" />-->
              <span>撤回审核</span>
            </div>
            <div
              class="flex align-items-center"
              style="cursor: pointer; color: #e5914b"
              v-if="canSetApplyLevel(record)"
              @click="openSetLevel(record)"
            >
              <span>设置级别</span>
            </div>
            <div
              class="flex align-items-center"
              style="cursor: pointer; color: #e5914b"
              @click="previews(record)"
            >
              <!-- <img
              class="img-box-preview"
              src="../../assets/images/img51.png"
              alt=""
            /> -->
              <span>预览</span>
            </div>
            <!--<div
            class="flex align-items-center"
            style="cursor: pointer"
            @click="previews(record)"
          >
            <img class="img-box" src="../../assets/images/img56.png" alt="" />
                                   审核
          </div>-->
          </template>
        </span>
        <div
          class="flex align-items-center"
          style="cursor: pointer; justify-content: center"
          @click="zjlist(record)"
        >
          <img
            class="img-box-preview"
            src="../../assets/images/img51.png"
            alt=""
          />
          <span>评分</span>
        </div>
      </a-table>
    </div>
    <div class="preview-pop-box" v-if="showPreviewPop">
      <div :class="fullscreen ? 'preview-box-fullscreen' : 'preview-box'">
        <preview
          :preViewData="preViewData"
          type="school"
          @goNewPage="goNewPage"
          @closePreview="showPreviewPop = false"
        >
        </preview>
      </div>
    </div>
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <tablesmic
          :title="title"
          :num="num"
          :record="record"
          @closePreview="showtable = false"
        >
        </tablesmic>
      </div>
    </div>
    <div class="preview-pop-box" v-if="showiframe">
      <div class="preview-boxs" style="height: 90%">
        <newpreview
          :previewUrl="previewUrl"
          @closePreview="showiframe = false"
        ></newpreview>
      </div>
    </div>
    <div class="preview-pop-box" v-if="showvideo">
      <div class="preview-boxs" style="height: 600px">
        <videopreview
          :sj="sjData"
          :previewUrl="previewUrl"
          @closePreview="showvideo = false"
        ></videopreview>
      </div>
    </div>
    <a-modal
      v-model="visible"
      title="确定要驳回吗？"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOks()"
      @cancel="visible = false"
    >
      <p>驳回的理由是什么呢？</p>
      <a-input
        type="text"
        v-model="content"
        name=""
        id=""
        style="width: 100%; height: 50px"
        placeholder="请输入驳回的理由!"
      />
    </a-modal>
    <a-modal
      v-model="levelVisible"
      title="设置项目级别"
      ok-text="确认"
      cancel-text="取消"
      @ok="confirmSetLevel"
      @cancel="levelVisible = false"
    >
      <p>请选择该项目级别：</p>
      <a-radio-group v-model="levelValue" name="applyLevel">
        <a-radio :value="1">省级</a-radio>
        <a-radio :value="2">市级</a-radio>
      </a-radio-group>
    </a-modal>
  </div>
</template>

<script>
import tablesmic from "./tableszMic";
import preview from "./preview";
import newpreview from "./newpreview";
import videopreview from "./videopreview";
import { schoolMaxNum } from "../../api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
import { getAction, postAction, putAction, deleteAction, setApplyLevel } from "@/api/index";
import { getAuditLevel } from "@/api/auditTask.js";
import {
  getCourseAuditStateText,
  getCourseAuditStateColor,
  parseCourseAuditFilter,
} from "@/components/projectShell/moduleConfig.js";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "学校名称",
    dataIndex: "schoolName",
    id: "schoolName",
    align: "center",
    width: 180,
    customRender: (text, record) => {
      // getApplyOverviewList 返回 schoolName；兼容旧接口返回的 realname
      return record.schoolName || record.realname || text || "-";
    },
  },
  {
    title: "工作室名称",
    dataIndex: "name",
    id: "name",
    align: "center",
    width: 150,
  },
  {
    title: "工作室地点",
    dataIndex: "address",
    id: "address",
    align: "center",
    width: 150,
  },
  {
    title: "审核状态",
    dataIndex: "auditState",
    id: "auditState",
    align: "center",
    scopedSlots: { customRender: "auditState" },
    width: 150,
  },
  {
    title: "项目级别",
    dataIndex: "applyLevelText",
    id: "applyLevelText",
    align: "center",
    width: 100,
    customRender: (text) => text || "-",
  },
  {
    title: "工作室建设日期",
    dataIndex: "foundTime",
    id: "foundTime",
    align: "center",
    width: 150,
  },
  {
    title: "申报年份",
    dataIndex: "applyYear",
    id: "applyYear",
    align: "center",
    width: 100,
  },
  {
    title: "工作室团队成员",
    dataIndex: "groupNum",
    id: "groupNum",
    align: "center",
    scopedSlots: { customRender: "xtdcy" },
    width: 150,
  },
  // {
  //     title: "资金",
  //     dataIndex: "brandMode",
  //     id: "brandMode",
  //     align: "center",
  //     scopedSlots: { customRender: "zjyl" },
  //     width: 100,
  // },
  {
    title: "成果",
    dataIndex: "achievementNum",
    id: "achievementNum",
    align: "center",
    scopedSlots: { customRender: "cgyl" },
    width: 100,
  },
  {
    title: "思政实践基地",
    dataIndex: "szBaseNum",
    id: "szBaseNum",
    align: "center",
    scopedSlots: { customRender: "brandArea" },
    width: 140,
  },
  {
    title: "申报书",
    dataIndex: "declarationName",
    id: "declarationName",
    align: "center",
    scopedSlots: { customRender: "sbs" },
    width: 100,
  },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 244,
    fixed: "right",
    scopedSlots: { customRender: "action" },
  },
];
export default {
  name: "",
  components: { preview, tablesmic, newpreview, videopreview },
  props: {
    columns: {
      type: Array,
      default: () => columns,
    },
    loading: Boolean,
    dataList: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: "",
    },
    pagination: {
      type: Object,
    },
    btnShow: {
      type: Boolean,
    },
  },
  data() {
    return {
      visible: false,
      content: "",
      // 设置项目级别
      levelVisible: false,
      levelValue: 1,
      levelRecord: {},
      showtable: false,
      title: "",
      num: 0,
      record: {},
      showDeleteModel: false,
      deteleId: null,
      showPreviewPop: false,
      fullscreen: false,
      preViewData: null,
      queryCriteria: {
        name: "",
        applyYear: "",
        auditState: "",
      },
      data: [],
      previewUrl: "",
      showiframe: false,
      showvideo: false,
      isadd: "",
      zh_CN,
      locale,
      yearShowOne: false,
      selectedRowKeys: [],
      isMul: 0,
      sjData: {},
    };
  },
  computed: {
    isCourseType() {
      return this.type === "szMicroClass" || this.$route.name === "szMicroClass";
    },
    /** 工作室/品牌/微课为两级审核模块；最美中职班主任等为简单审核 */
    isTwoLevelModule() {
      const route = this.$route.name;
      return (
        route === "szStudio" ||
        route === "educationalBrand" ||
        route === "szMicroClass"
      );
    },
    /** 审核状态筛选选项，与角色对应
     *  教育厅(education-guide-role) 仅见：审核通过
     *  教育局/评分员(education-role / score-role) 仅见：待教育局/厅审核、审核通过、教育局驳回
     *  非两级审核模块（如最美中职班主任）仅见：待审核、审核通过 */
    twoLevelFilterOptions() {
      if (!this.isTwoLevelModule) {
        return [
          { value: "1", label: "待审核" },
          { value: "2", label: "审核通过" },
        ];
      }
      const role = this.$store.state.role;
      // 教育厅角色只查看教育局/厅审核通过的数据
      if (role === "education-guide-role") {
        return [{ value: "2", label: "审核通过" }];
      }
      if (role === "education-role" || role === "score-role") {
        return [
          { value: "1-2", label: "待教育局/厅审核" },
          { value: "2", label: "审核通过" },
          { value: "3-2", label: "教育局驳回" },
        ];
      }
      return [
        { value: "1-1", label: "待学校审核" },
        { value: "1-2", label: "待教育局/厅审核" },
        { value: "2", label: "审核通过" },
        { value: "3-1", label: "学校驳回" },
        { value: "3-2", label: "教育局驳回" },
      ];
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        getCheckboxProps: this.getCheckboxProps,
        // 其他 row-selection 的配置
      };
    },
  },
  watch: {
    dataList(newPrice) {
      this.data = newPrice;
    },
    isadd(newPrice) {
      this.isadd = newPrice;
    },
  },
  created() {},
  mounted() {},
  methods: {
    courseStatusText(record) {
      return getCourseAuditStateText(record);
    },
    courseStatusColor(record) {
      return getCourseAuditStateColor(record);
    },
    canEducationAudit(record) {
      if (this.$store.state.role === "education-guide-role") return false;
      if (record.auditState != "1") return false;
      if (!this.isCourseType) return true;
      return String(record.auditLevel) === "2";
    },
    /** 教育局/厅角色，仅终审通过(auditState=2)的工作室/品牌/微课可设置级别；
     *  education-guide-role 仅只读，不展示设置级别 */
    canSetApplyLevel(record) {
      const role = this.$store.state.role;
      if (role !== "education-role") {
        return false;
      }
      return String(record.auditState) === "2";
    },
    openSetLevel(record) {
      this.levelRecord = record;
      this.levelValue = Number(record.applyLevel) === 2 ? 2 : 1;
      this.levelVisible = true;
    },
    confirmSetLevel() {
      const record = this.levelRecord;
      if (!record || !record.id) {
        this.$message.warning("未找到要设置级别的项目");
        return;
      }
      setApplyLevel({
        applyIds: [record.id],
        applyLevel: this.levelValue,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success("设置级别成功");
          this.levelVisible = false;
          this.inquire();
        } else {
          this.$message.error(res.message || "设置级别失败");
        }
      });
    },
    pl(num) {
      console.log(this.selectedRowKeys);
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量操作的数据");
        return false;
      }
      if (num == "0") {
        let params = {};
        params.auditState = 2;
        params.applyIds = this.selectedRowKeys;
        params.auditLevel = getAuditLevel(this.$store.state.role);
        postAction("/lx/lxApply/auditBatch", params).then((res) => {
          if (res.code === 200) {
            this.$message.success("审核通过成功");
            this.selectedRowKeys = [];
            this.inquire();
          }
        });
      } else {
        this.content = "";
        this.isMul = 1;
        this.visible = true;
      }
    },
    getCheckboxProps(record) {
      const canCheck = this.isCourseType
        ? record.auditState == "1" && String(record.auditLevel) === "2"
        : record.auditState == "1";
      return {
        props: {
          disabled: !canCheck,
        },
      };
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    previews(row) {
      // this.showPreviewPop = true;
      // this.preViewData = row;
      this.$emit("editInfo", row, "preview");
    },
    chsh(record) {
      let params = {};
      // params.auditState=2;
      params.applyIds = [];
      params.applyIds.push(record.id);
      postAction("/lx/lxApply/withdrawAudit", params).then((res) => {
        if (res.code === 200) {
          this.$message.success("撤回审核成功");
          this.inquire();
        }
      });
    },
    approved(num, record) {
      //		console.log(num,record);
      let params = {};
      if (num == "0") {
        params.auditState = 2;
        params.applyIds = [];
        params.applyIds.push(record.id);
        params.auditLevel = getAuditLevel(this.$store.state.role);
        postAction("/lx/lxApply/auditBatch", params).then((res) => {
          if (res.code === 200) {
            this.$message.success("审核通过成功");
            this.selectedRowKeys = [];
            this.inquire();
          }
        });
      } else {
        this.isMul = 0;
        this.content = "";
        this.visible = true;
        this.record = record;
      }
    },
    handleOks() {
      if (this.content == "") {
        this.$message.warning("请填写驳回理由");
        return false;
      }
      let params = {};
      params.auditState = 3;
      params.applyIds = [];
      if (this.isMul == "0") {
        params.applyIds.push(this.record.id);
      } else {
        params.applyIds = this.selectedRowKeys;
      }

      params.auditDesc = this.content;
      params.auditLevel = getAuditLevel(this.$store.state.role);
      postAction("/lx/lxApply/auditBatch", params).then((res) => {
        if (res.code === 200) {
          this.$message.success("审核驳回成功");
          this.visible = false;
          this.selectedRowKeys = [];
          this.isMul = 0;
          this.inquire();
        }
      });
    },
    xteacherlist(record) {
      if (this.$route.name === "szStudio") {
        this.title = "工作室团队成员预览";
      } else if (this.$route.name === "educationalBrand") {
        this.title = "品牌团队成员预览";
      }
      this.num = 6;
      this.record = record;
      this.showtable = true;
    },
    teacherlist(record) {
      this.title = "团队成员预览";
      this.num = 0;
      this.record = record;
      this.showtable = true;
    },
    previews(row) {
      //    this.showPreviewPop = true;
      //    this.preViewData = row;
      this.$emit("editInfo", row, "preview");
    },
    arealist(record) {
      this.title = "合作基地预览";
      this.num = 5;
      this.record = record;
      this.showtable = true;
    },
    ppjd(record) {
      this.title = "品牌基地";
      this.num = 3;
      this.record = record;
      this.showtable = true;
    },
    pphd(record) {
      this.title = "品牌活动";
      this.num = 4;
      this.record = record;
      this.showtable = true;
    },
    zjlist(record) {
      this.title = "资金预览";
      this.num = 1;
      this.record = record;
      this.showtable = true;
    },
    cglist(record) {
      this.title = "标志性成果预览";
      this.num = 2;
      this.record = record;
      this.showtable = true;
    },
    sbs(record) {
      console.log(record);
      if (
        record.declarationName != "" &&
        record.declarationName != null &&
        record.declarationPath != "" &&
        record.declarationPath != null
      ) {
        this.showiframe = true;
        this.previewUrl = record.declarationPath;
      } else {
        this.$message.warning("申报书暂未上传，请上传后预览");
      }
    },
    sp(record) {
      if (record.hasResource == "0") {
        this.$message.warning("思政视频暂未上传，请上传后预览");
      } else {
        getAction("/lxBase/lxApplyResource/getResourceByApplyId", {
          applyId: record.id,
        }).then((res) => {
          if (res.code === 200) {
            console.log(res, "111111");
            this.sjData = res.result;
            if (this.sjData.aliId) {
              this.showvideo = true;
            }
            console.log(this.sjData, ";222222222222222");
            // this.previewUrl = res.result.filePath;
          }
        });
      }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    // 得到年份选择器的值
    panelChangeOne(value) {
      //   	    console.log(value,"111111");
      this.queryCriteria.applyYear = value;
      this.yearShowOne = false;
    },
    handleChange(value) {
      this.queryCriteria.auditState = value;
    },
    inquire(type) {
      console.log("type", type);
      const pagination = {
        current: 1,
        pageSize: 10,
      };
      this.handleTableChange(pagination, type);
    },
    goNewPage(flag) {
      console.log(flag);
      this.fullscreen = flag;
    },
    handleTableChange(pagination, type) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      let queryParam = {};
      queryParam.page = pagination.current;
      queryParam.size = pagination.pageSize;
      if (this.isTwoLevelModule) {
        // 工作室/品牌/微课为两级审核，解析 auditState-auditLevel 组合筛选值
        const parsed = parseCourseAuditFilter(this.queryCriteria.auditState);
        queryParam.auditState = parsed.auditState || "";
        if (parsed.auditLevel != null) queryParam.auditLevel = parsed.auditLevel;
      } else {
        queryParam.auditState = this.queryCriteria.auditState;
      }
      queryParam.name = this.queryCriteria.name;
      if (this.queryCriteria.applyYear != "") {
        queryParam.applyYear =
          new Date(this.queryCriteria.applyYear).getFullYear() + "";
      }
      if (type === 1) {
        this.$emit("lxApplyExportZip", this.params);
      } else {
        this.$emit("getLxApplyjyjApplylist", queryParam);
      }
      //    this.init();
    },
    handleOk() {
      this.showDeleteModel = false;
      this.$emit("deleteApply", this.deteleId);
    },
    deleteInfo(row) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    editInfo(row) {
      this.$emit("editInfo", row);
    },
    preview(row) {
      this.showPreviewPop = true;
      this.preViewData = row;
      //    this.$emit("editInfo", row,'preview');
    },
  },
};
</script>

<style scoped lang="scss">
.header-time-box {
  width: 363px;
  height: 32px;
  line-height: 30px;
  text-align: center;
  background: rgba(156, 3, 5, 0.1);
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2155b5;
  border-radius: 10px;
}

.add-btn {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #2155b5;
  border-radius: 6px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.mb8 {
  margin-bottom: 8px;
}

.img-box {
  width: 18px;
  height: 18px;
  margin-right: 9px;
}

.img-box-preview {
  width: 21px;
  height: 21px;
  margin-right: 9px;
}

.table-box {
  text-align: center;
}

.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);

  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }

  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }

  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}

.header-search-box {
  font-size: 14px;
  padding-left: 7px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #383838;
  margin-top: 10px;
  margin-bottom: 15px;

  .input-style {
    width: 180px;
    height: 30px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    padding: 8px 12px;
    margin: 0 20px 0 6px;
  }

  .search-btn {
    width: 100px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    text-align: center;
    color: #fff;
    background: #2155b5;
    border-radius: 6px;
    margin-left: 10px;

    // margin-right: 10px;
    .img-box {
      width: 12px;
      height: 14px;
      margin-right: 8px;
    }
  }
}

.img-box-hint {
  width: 18px;
  height: 18px;
  margin-right: 9px;
  display: inline-block;
  margin: 0 auto;
}
</style>
